/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusErlassOptionDto } from '../../models/lexplus-erlass-option-dto';

export interface ErlassControllerGetErlassDropdownOptionsV1$Params {
}

export function erlassControllerGetErlassDropdownOptionsV1(http: HttpClient, rootUrl: string, params?: ErlassControllerGetErlassDropdownOptionsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusErlassOptionDto>>> {
  const rb = new RequestBuilder(rootUrl, erlassControllerGetErlassDropdownOptionsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusErlassOptionDto>>;
    })
  );
}

erlassControllerGetErlassDropdownOptionsV1.PATH = '/v1/compliance/erlasse/dropdown-options';
